import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import settingService from './settingService'

const initialState = {
  holiday: null,
  holiday_list: null,
  holidayLoading: false,

  exceptionalHoliday: null,
  brands: null,
  prefectures: null,
  exceptionalLoading: false,

  settingError: null,
}

// @desc Get Holiday
export const getHoliday = createAsyncThunk(
  'holiday/get',
  async (token, thunkAPI) => {
    try {
      return await settingService.getHoliday(token)
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
)

// @desc Add Holiday
export const addHoliday = createAsyncThunk(
  'holiday/add',
  async ({ data, token }, thunkAPI) => {
    try {
      return await settingService.addHoliday(data, token)
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
)

// @desc Delete Holiday
export const deleteHoliday = createAsyncThunk(
  'holiday/delete',
  async ({ data, token }, thunkAPI) => {
    try {
      return await settingService.deleteHoliday(data, token)
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
)

// Exceptional
// @desc Get Brands
export const getBrands = createAsyncThunk(
  'exceptional/get_brands',
  async (token, thunkAPI) => {
    try {
      return await settingService.getBrands(token)
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  }
)

// @desc Get Prefectures
export const getPrefectures = createAsyncThunk(
  'exceptional/get_prefectures',
  async (token, thunkAPI) => {
    try {
      return await settingService.getPrefectures(token)
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  }
)

// @desc Get Exceptional Holiday
export const getExceptionalHoliday = createAsyncThunk(
  'exceptional_holiday/get',
  async (token, thunkAPI) => {
    try {
      return await settingService.getExceptionalHoliday(token)
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  }
)

// @desc Add Holiday
export const addExceptionalHoliday = createAsyncThunk(
  'exceptional_holiday/add',
  async ({ data, token }, thunkAPI) => {
    try {
      return await settingService.addExceptionalHoliday(data, token)
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  }
)

// @desc Delete Holiday
export const deleteExceptionalHoliday = createAsyncThunk(
  'exceptional_holiday/delete',
  async ({ data, token }, thunkAPI) => {
    try {
      return await settingService.deleteExceptionalHoliday(data, token)
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  }
)

export const settingSlice = createSlice({
  name: 'setting',
  initialState,
  reducers: {
    resetSetting: (state) => {
      state.holiday = null
      state.holiday_list = null
      state.exceptionalHoliday = null
      state.brands = null
      state.prefectures = null
      state.settingError = null
    },
    setHolidayList: {
      reducer: (state, action) => {
        state.holiday_list = []
        state.holiday_list.push(action.payload)
      },
      prepare: (value) => {
        return {
          payload: value.map((val) => ({
            value: val,
            checked: false,
          })),
        }
      },
    },
  },
  extraReducers: (builder) => {
    builder
      // GET Holiday
      .addCase(getHoliday.pending, (state) => {
        state.holidayLoading = true
      })
      .addCase(getHoliday.fulfilled, (state, action) => {
        state.holiday = action.payload.res.data
        state.holidayLoading = false
      })
      .addCase(getHoliday.rejected, (state, action) => {
        state.settingError = action.payload
        state.holidayLoading = false
      })
      // Add Holiday
      .addCase(addHoliday.pending, (state) => {
        state.holidayLoading = true
      })
      .addCase(addHoliday.fulfilled, (state) => {
        state.holidayLoading = false
      })
      .addCase(addHoliday.rejected, (state, action) => {
        state.settingError = action.payload
        state.holidayLoading = false
      })
      // Delete Holiday
      .addCase(deleteHoliday.pending, (state) => {
        state.holidayLoading = true
      })
      .addCase(deleteHoliday.fulfilled, (state) => {
        state.holidayLoading = false
      })
      .addCase(deleteHoliday.rejected, (state, action) => {
        state.settingError = action.payload
        state.holidayLoading = false
      })

      // Exceptional
      // GET Brands
      .addCase(getBrands.pending, (state) => {
        state.exceptionalLoading = true
      })
      .addCase(getBrands.fulfilled, (state, action) => {
        state.brands = action.payload
        state.exceptionalLoading = false
      })
      .addCase(getBrands.rejected, (state) => {
        state.exceptionalLoading = false
      })
      // GET Prefectures
      .addCase(getPrefectures.pending, (state) => {
        state.exceptionalLoading = true
      })
      .addCase(getPrefectures.fulfilled, (state, action) => {
        state.prefectures = action.payload
        state.exceptionalLoading = false
      })
      .addCase(getPrefectures.rejected, (state) => {
        state.exceptionalLoading = false
      })

      // Get Exceptional Holiday
      .addCase(getExceptionalHoliday.pending, (state) => {
        state.exceptionalLoading = true
      })
      .addCase(getExceptionalHoliday.fulfilled, (state, action) => {
        state.exceptionalLoading = false
        state.exceptionalHoliday = action.payload
      })
      .addCase(getExceptionalHoliday.rejected, (state) => {
        state.exceptionalLoading = false
      })
      // Add Exceptional Holiday
      .addCase(addExceptionalHoliday.pending, (state) => {
        state.exceptionalLoading = true
      })
      .addCase(addExceptionalHoliday.fulfilled, (state) => {
        state.exceptionalLoading = false
      })
      .addCase(addExceptionalHoliday.rejected, (state) => {
        state.exceptionalLoading = false
      })
  },
})

export const { resetSetting, setHolidayList } = settingSlice.actions

export default settingSlice.reducer
